import { Link } from "react-router-dom";

import ShowAllIcon from "@mui/icons-material/FormatListBulletedRounded";
import { Box, IconButton, Typography } from "@mui/material";

import { CounselorSelect } from "@/common/components/counselor-select/CounselorSelect";
import { AppRoutes } from "@/router/AppRoutes";
import { useTranslation } from "@/translations";

import { AssignmentCreationButton } from "./components/assignment-creation/AssignmentCreationButton";

interface Props {
  count: number;
  selectedCounselorId: string | null;
  onCounselorChange: (counselorId: string | null) => void;
}

export function AssignmentsHeader({ count, selectedCounselorId, onCounselorChange }: Props) {
  const { t } = useTranslation();

  return (
    <Box
      px={2}
      py={0.5}
      bgcolor={"fsw.blue-5"}
      justifyContent={"space-between"}
      display={"flex"}
      alignItems={"center"}
      gap={2}
    >
      <Typography variant="h6" whiteSpace={"nowrap"}>
        {t("assignments.openTitle", { count })}
      </Typography>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <CounselorSelect selectedCounselor={selectedCounselorId} onSelectCounselor={onCounselorChange} />
        <IconButton aria-label={t("assignments.showAll")} component={Link} to={AppRoutes.Assignments}>
          <ShowAllIcon />
        </IconButton>

        <AssignmentCreationButton />
      </Box>
    </Box>
  );
}
